var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLateDays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27,
    fill: "#F3F8FE",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8609 40.3938C38.0456 40.3938 44 34.3934 44 27.153C44 19.9258 38.0326 13.9121 30.8477 13.9121C24.2318 13.9121 18.6347 19.0458 17.8408 25.5128C21.9559 25.5795 25.4094 28.6197 26.1239 32.5933C27.5265 31.9933 29.154 31.6466 30.8609 31.6466C34.1159 31.6466 36.9871 32.8733 38.7337 34.7668C36.749 36.8336 33.9571 38.1403 30.8477 38.1403C29.0217 38.1403 27.3015 37.6736 25.7931 36.8869C25.5549 37.5936 25.2374 38.2603 24.8007 38.887C26.6399 39.8471 28.6909 40.3938 30.8609 40.3938ZM30.8477 29.4064C28.3203 29.4064 26.4017 27.1797 26.4017 24.4061C26.4017 21.7793 28.3601 19.4991 30.8477 19.4991C33.3484 19.4991 35.32 21.7793 35.3067 24.4061C35.3067 27.1797 33.3881 29.4064 30.8477 29.4064ZM17.7217 40.9005C21.4134 40.9005 24.4435 37.8603 24.4435 34.1267C24.4435 30.4199 21.4134 27.353 17.7217 27.353C14.0433 27.353 11 30.4199 11 34.1267C11 37.8603 14.0433 40.9005 17.7217 40.9005ZM17.7217 35.1935C17.2851 35.1935 16.9675 34.9001 16.9543 34.4601L16.8484 30.7798C16.8352 30.2598 17.1925 29.8998 17.7217 29.8998C18.2642 29.8998 18.6083 30.2598 18.595 30.7798L18.4892 34.4601C18.476 34.9001 18.1716 35.1935 17.7217 35.1935ZM17.7217 38.3803C17.1263 38.3803 16.6368 37.8869 16.6368 37.2869C16.6368 36.6869 17.1263 36.1935 17.7217 36.1935C18.3304 36.1935 18.8067 36.6869 18.8067 37.2869C18.8067 37.8869 18.3304 38.3803 17.7217 38.3803Z",
    fill: "#4297FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLateDays);
export default __webpack_public_path__ + "static/media/lateDays.5e704f3338cadbcf6bfe801e2c0ac9a0.svg";
export { ForwardRef as ReactComponent };